<h1 mat-dialog-title i18n>Resend Verification <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form (ngSubmit)="onFormSubmit()">
	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				[disabled]="false"
				i18n
				cdkFocusInitial
			>Ok</button>
		</div>
	</div>
</form>
